import BackIcon from "../assets/icons/back-icon"
import DefaultCompanyIcon from "../assets/icons/default-company-icon"
import WalletIcon from "../assets/icons/wallet-icon"
import WorkLocationIcon from "../assets/icons/work-location-icon"
import { EVENTS } from "../shared/constants/MIXAPANEL_EVENTS"
import { useAssessmentStore } from "../shared/store"
import { getSectionName, trackMixpanelEvent } from "../utils/helpers"

const JobDetailSummary = () => {
    const {
        jobDetails,
        setOpenExitFlow,
        assesmentQuestions,
        currentStep,
        screenDetails,
        answeredQuestions,
    } = useAssessmentStore((state) => state)
    // get data from store and update
    const type = assesmentQuestions?.questions[currentStep]?.question_type
    const numberOfQuestions = assesmentQuestions?.questions[currentStep]?.questions.length

    const tagIds: number[] = []
    assesmentQuestions?.questions[currentStep]?.questions.forEach((element) => {
        tagIds.push(element.tags[0])
    })
    const handleClose = () => {
        trackMixpanelEvent(EVENTS.ASSESSMENT_BACKPRESS, {
            "Page shown": getSectionName(type),
            "Application id": screenDetails.application_id,
            "No. of questions shown": numberOfQuestions,
            "Tag id of assets shown": tagIds,
            "Questions with ans": answeredQuestions,
        })
        // open the bottom sheet
        setOpenExitFlow(true)
    }
    const jobData = jobDetails?.job_info
    return (
        <div className="px-4 py-2">
            <button onClick={handleClose}>
                <BackIcon />
            </button>
            <div className="flex justify-between mb-2">
                <div className="flex flex-row gap-2">
                    {!jobData?.organization?.logo_url ? (
                        <DefaultCompanyIcon />
                    ) : (
                        <img
                            className="h-10 w-auto"
                            src={jobData.organization.logo_url}
                            alt=""
                        />
                    )}

                    <div className="flex flex-col text-sm text-onSurface-secondary">
                        <span className="font-normal">{jobData?.title}</span>
                        <span className="font-extralight">
                            {jobData?.organization?.name}
                        </span>
                    </div>
                </div>
                {/* <div>
                    <CrossIcon onClick={handleClose} />
                </div> */}
            </div>
            <div className="flex flex-col gap-2.5">
                {jobData?.company_address?.area?.name && (
                    <div className="flex gap-2.5 ">
                        <WorkLocationIcon />
                        <span className="text-xs text-onSurface-secondary">
                            {jobData?.company_address?.area?.name}
                        </span>
                    </div>
                )}

                {jobData?.max_salary && jobData?.max_salary !== 0 && (
                    <div className="flex gap-2.5">
                        <WalletIcon />
                        {jobData?.min_salary !== 0 ? (
                            <span className="text-xs text-onSurface-secondary">
                                ₹{jobData?.min_salary} - ₹{jobData?.max_salary}
                            </span>
                        ) : (
                            <span className="text-xs text-onSurface-secondary">
                                ₹{jobData?.max_salary}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default JobDetailSummary
